function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1602 46.6564L29.8009 33.0852L35.9463 37.4606L43.7776 26.4355L44.3758 31.1027",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M38.8564 27.4688L43.7757 26.4355",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M63.6614 46.4545C70.3429 46.4545 75.7593 44.5752 75.7593 42.257C75.7593 39.9388 70.3429 38.0596 63.6614 38.0596C56.9799 38.0596 51.5635 39.9388 51.5635 42.257C51.5635 44.5752 56.9799 46.4545 63.6614 46.4545Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M75.7593 47.2158C75.7593 49.5345 70.3407 51.4133 63.6614 51.4133C56.9821 51.4133 51.5635 49.5345 51.5635 47.2158",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M75.7593 52.1689C75.7593 54.4877 70.3407 56.3664 63.6614 56.3664C56.9821 56.3664 51.5635 54.4877 51.5635 52.1689",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M75.7593 57.1279C75.7593 59.4467 70.3407 61.3254 63.6614 61.3254C56.9821 61.3254 51.5635 59.4467 51.5635 57.1279",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M59.894 66.0718C59.9287 66.0767 59.9633 66.0817 60.0028 66.0866C60.0275 66.0866 60.0522 66.0915 60.077 66.0915H60.0819C61.2141 66.2151 62.4155 66.2794 63.6614 66.2794C70.3456 66.2794 75.7642 64.4007 75.7642 62.0869",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M51.5635 62.808V60.2866V42.2559",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M75.7598 42.2559V62.0862",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M47.906 71.1986C54.5875 71.1986 60.004 69.3193 60.004 67.0011C60.004 64.683 54.5875 62.8037 47.906 62.8037C41.2245 62.8037 35.8081 64.683 35.8081 67.0011C35.8081 69.3193 41.2245 71.1986 47.906 71.1986Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M60.003 71.96C60.003 74.2787 54.5844 76.1574 47.9051 76.1574C41.2257 76.1574 35.8071 74.2787 35.8071 71.96",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M35.8071 67.001V71.9598",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M60.0024 67.001V71.9598",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M41.5361 3.98015L50.287 2.14098C54.262 1.30545 57.9057 3.8961 58.4248 7.93533L61.8213 34.262",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2687 8.66699L8.17939 11.0006C4.19948 11.8361 1.39624 15.7863 1.91041 19.8206L7.95691 66.9615C8.47603 70.9958 12.1197 73.5864 16.0947 72.7509L36.0733 68.5485L36.2711 68.509",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1298 56.1878L8.57147 20.6504C8.31438 18.6333 9.71353 16.6705 11.6961 16.2503L19.3098 14.6484",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M50.5804 58.2354L23.8779 63.8567",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M42.1348 9.84877L48.2653 8.55839C50.2478 8.14309 52.0672 9.42853 52.3243 11.4457L55.4687 35.2262",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M41.6008 13.7446L19.3331 18.4266L19.249 5.84412L41.5167 1.15723L41.6008 13.7446Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M13.1284 56.1888L23.8717 63.8273L22.6357 54.1865L13.1284 56.1888Z",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "M37.0382 4.92969C35.3968 6.54143 33.3253 7.71809 30.9868 8.21249C28.6482 8.70689 26.3987 8.43992 24.4409 7.57966",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M75.7598 61.0479H83.7591",
  stroke: "#4C2C89",
  strokeWidth: 2,
  strokeMiterlimit: 10,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function Svg5Franqueado(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 78,
    viewBox: "0 0 85 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Franqueado);
export default __webpack_public_path__ + "static/media/5-franqueado.f3d8e6462c92f9aad97d303e5fb13103.svg";
export { ForwardRef as ReactComponent };